'use client';

import { domAnimation, LazyMotion, m } from 'motion/react';
import { usePathname } from 'next/navigation';

import type { ReactNode } from 'react';

type PageTransitionProps = {
    children: ReactNode;
};

export function PageTransition({ children }: PageTransitionProps) {
    const pathname = usePathname();

    return (
        <LazyMotion features={domAnimation} strict>
            <m.div
                key={pathname}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.25, ease: 'easeOut' }}
            >
                {children}
            </m.div>
        </LazyMotion>
    );
}
